import { onScopeDispose, ref } from "vue";
import {
  errorMessage,
  validationFieldErrors,
} from "@/composables/generated/contracts";

export function usePersonProfileAction() {
  const saving = ref(false);
  const error = ref("");
  const fieldErrors = ref<Record<string, string>>({});
  let disposed = false;
  onScopeDispose(() => {
    disposed = true;
  });
  function clear() {
    error.value = "";
    fieldErrors.value = {};
  }
  async function save(action: () => Promise<unknown>) {
    if (saving.value || disposed) return false;
    saving.value = true;
    clear();
    try {
      await action();
      return !disposed;
    } catch (cause) {
      if (!disposed) {
        error.value = errorMessage(cause);
        fieldErrors.value = validationFieldErrors(cause);
      }
      return false;
    } finally {
      if (!disposed) saving.value = false;
    }
  }
  return { saving, error, fieldErrors, clear, save };
}
